export enum Result {
  Success = 'success',
  Failure = 'failure',
  Declined = 'declined',
  Ineligible = 'ineligible',
  AlreadyPerformed = 'alreadyPerformed',
  Interrupted = 'interrupted'
}
